import { render, staticRenderFns } from "./ProductRowBestPrice.vue?vue&type=template&id=1325c02e&scoped=true&"
import script from "./ProductRowBestPrice.vue?vue&type=script&lang=js&"
export * from "./ProductRowBestPrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductRowBestPrice.vue?vue&type=style&index=0&id=1325c02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325c02e",
  null
  
)

export default component.exports